import request from '@/utils/request'

export function get(id){
  return request({
    url: '/inventoryPlans/get?id='+id,
    method: 'get',
  })
}

export function StartInventory(id){
  return request({
    url: '/inventoryPlans/StartInventory?id='+id,
    method: 'post',
  })
}

export function FinishInventory(id){
  return request({
    url: '/inventoryPlans/FinishInventory?id='+id,
    method: 'post',
  })
}

export function GetInventoryDetail(id){
  return request({
    url: '/inventoryPlans/GetInventoryDetail?code='+id,
    method: 'get',
  })
}

export function getList(params) {
  return request({
    url: '/inventoryPlans/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/inventoryPlans/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/inventoryPlans/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/inventoryPlans/delete',
    method: 'post',
    data
  })
}

export function GetStoretions(){
  return request({
    url: '/inventoryPlans/GetStoretions',
    method: 'get',
  })
}
export function GetDeptions(){
  return request({
    url: '/inventoryPlans/GetDeptions',
    method: 'get',
  })
}

export function QueryInventoryDetail(previousStoreName,previousDepartment){
  return request({
    url: '/inventoryPlans/QueryInventoryDetail?previousStoreName='+previousStoreName+'&previousDepartment='+previousDepartment,
    method: 'get',

})
}

export function GetInventoryPerson(tenantCode){
  return request({
    url: '/inventoryPlans/GetInventoryPerson?TenantCode='+tenantCode,
    method: 'get',
  })
}
